const api = '/api/v1/u015_p_ship_code_controller.php';
import axios from 'axios';
export const ship_code_repository =  {
    get(sell_id){
        return  axios.get(`${api}?SELL_ID=${sell_id}`);
    }
};

